// Utils
import { useEffect } from 'react';
import MicroModal from 'micromodal';

// Components
import { useAppContext } from '../../store/AppContext';

const useModal = () => {
  const [{ modal }, stateDispatch] = useAppContext();

  useEffect(() => {
    if (modal?.id) {
      MicroModal.show(modal.id, {
        onClose: () => {
          setTimeout(() => {
            stateDispatch({ type: 'SET_MODAL', payload: null });
          }, 250);
        },
      });
    }
  }, [modal]);

  const displayModal = ({
    title, content, buttons, maxWidth, coverImage, fullHeight,
  }) => {
    if (!modal) {
      const modalId = `modal_${Date.now()}`;

      const config = {
        id: modalId,
        title: title || '',
        content,
        buttons,
        maxWidth,
        coverImage,
        fullHeight,
      };

      stateDispatch({ type: 'SET_MODAL', payload: config });
    }
  };

  const updateModalProps = (key, value) => {
    if (modal && key && value) {
      stateDispatch({
        type: 'SET_MODAL',
        payload: { ...modal, content: { ...modal.content, props: { ...modal.content.props, [key]: value } } },
      });
    }
  };

  const closeModal = () => {
    if (modal?.id) {
      MicroModal.close(modal.id);

      setTimeout(() => {
        stateDispatch({ type: 'SET_MODAL', payload: null });
      }, 250);
    }
  };

  return {
    displayModal,
    closeModal,
    updateModalProps,
  };
};

export default useModal;
